import { RootState } from '@/store/store'

export const selectSettingsLastFetched = (state: RootState) => state.chatUxState.settingsLastFetched
export const selectSettingsLoaded = (state: RootState) => state.chatUxState.settingsLastFetched !== null
export const selectSettingsFetchIsLoading = (state: RootState) => state.chatUxState.settingsFetchIsLoading
export const selectDefaultJurisdiction = (state: RootState) => state.chatUxState.defaultJurisdiction
export const selectCustomInstructions = (state: RootState) => state.chatUxState.customInstructions

export const selectResearchContactPromptCompleted = (state: RootState) => state.chatUxState.researchContactPromptCompleted
